import $ from "jquery";

const screencheck = function (mediasize) {
  let screensize = window.matchMedia("(max-width:" + mediasize + "px)");
  return !!screensize.matches;
};

const scrollToAnchor = function (anchor) {
  if ($(anchor).length > 0) {
    $(".join-steps li").removeClass("active");
    let offsetTop = $(anchor).offset().top;
    $('.join-steps a[href="' + anchor + '"]')
      .parent()
      .addClass("active");
    let aktScrollPos = $(document).scrollTop();
    // Version 2: fixed Header gar nicht erst einblenden
    if (aktScrollPos > offsetTop) fixed = false;
    $(".join-steps li").each(function () {
      let hash = $(this).find("a").attr("href");
    });
    $("html, body")
      .stop()
      .animate({ scrollTop: offsetTop - 40 }, 300, function () {
        // Version 2: fixed Header gar nicht erst einblenden: Wert zurücksetzen
        window.setTimeout(() => {
          fixed = true;
        }, 300);
      });
  }
};

export const init = () => {
  // Footer Dropdown ----------------------------------------------------------
  $(".footer-col h5").on("click", function () {
    if (screencheck(567)) {
      let accordion = $(this).next("ul");
      if ($(accordion).is(":visible")) {
        $(this).removeClass("nav-open");
        $(accordion).slideUp("normal");
      }
      $(".footer-col h5").removeClass("nav-open");
      $(".footer-col ul").slideUp("normal");
      $(this).addClass("nav-open");
      $(accordion).slideDown("normal");
    }
  });
  if ($(".footer-links a").length > 0) {
    $(".footer-links a")
      .off("click")
      .on("click", function (event) {
        if ($(this).attr("href")) {
          let linkPath = $(this).attr("href").split("/");
          if (linkPath.length > 0) {
            let anchor = linkPath.pop();
            if (anchor.substring(0, 1) === "#" && $(anchor).length > 0) {
              event.preventDefault();
              scrollToAnchor(anchor);
            }
          }
        }
      });
  }
};
